import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Row,
  Table,
  Input,
  Col,
  InputGroup,
  InputGroupAddon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Spinner,
  Label,
} from "reactstrap";
import { isIterableArray } from "../../helpers/utils";
import FalconCardHeader from "../common/FalconCardHeader";
import PageHeader from "../common/PageHeader";
import FullPagination from "../common/pagination/FullPagination";
import { If, Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { getAllvisitor, visitorCheckIn } from "../../helpers/api/visitors";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import {
  faCheck,
  faHistory,
  faInfoCircle,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import ButtonIcon from "../common/ButtonIcon";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import SupportLink from "../root/support/components/SupportLink";
import moment from "moment";

const Visitors = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    condominium: { selectedCondominium },
    auth: {
      user: { role },
    },
  } = useSelector((state) => state);
  const [plateNumber, setPlateNumber] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [visitorId, setVisitorId] = useState(null);
  const [vehicle, setVehicle] = useState(false);
  const [textSearch, setTextSearch] = useState("");
  const [params, setParams] = useState({
    search: null,
    type: 1,
    property: location.state?.id || false,
    condominium: role === "manager" ? selectedCondominium : null,
  });

  useEffect(() => {
    if (role !== "manager") return;
    setParams((prev) =>
      prev.condominium === selectedCondominium
        ? prev
        : { ...prev, condominium: selectedCondominium }
    );
  }, [role, selectedCondominium]);

  const applyVisitorSearch = (value = textSearch) => {
    const term = typeof value === "string" ? value.trim() : "";
    setTextSearch(term);
    setParams((prev) => ({ ...prev, search: term || null }));
  };

  const {
    data,
    error,
    isLoading,
    mutate,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(getAllvisitor, params);

  console.log(data);

  const markCheckIn = () => {
    setSubmitting(true);
    let obj = {
      visitor_id: visitorId,
    };
    if (plateNumber) obj["plate_number"] = plateNumber;
    visitorCheckIn(obj)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.CREATED) {
          Toast.fire({
            type: "success",
            title: `Entrada marcada exitosamente.`,
          });
          mutate();
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => {
        setSubmitting(false);
        setVisitorId(null);
        setVehicle(false);
        collapseOneOpen(false);
        setPlateNumber("");
        setVehicle(false);
      });
  };

  const handleModalConfirm = () => (
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Confirmación</ModalHeader>
      <ModalBody>
        <Row>
          <Col tag={FormGroup}>
            <Label>¿Entrada con vehículo?</Label>
            <Input
              type="checkbox"
              value={vehicle}
              onChange={({ target }) => {
                setVehicle(target.checked);
              }}
              className="position-relative ml-2 mr-0"
            />
          </Col>
        </Row>
        {vehicle && (
          <Row form>
            <Col tag={FormGroup}>
              <Label>Placa del vehículo</Label>
              <Input
                type="text"
                onChange={({ target }) => setPlateNumber(target.value)}
              />
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            collapseOneOpen(false);
            setPlateNumber("");
            setVehicle(false);
          }}
        >
          Cancelar
        </Button>
        <Button
          data-testid="submit-button"
          color="primary"
          type="submit"
          disabled={submitting}
          onClick={markCheckIn}
        >
          Marcar entrada {submitting && <Spinner size="sm" color="white" />}
        </Button>
      </ModalFooter>
    </Modal>
  );

  return (
    <>
      <PageHeader
        title="Visitantes/Autorizados"
        titleTag="h2"
        description={
          role === "manager"
            ? `Gestiona cada uno de los visitantes o personas autorizadas de los propietarios`
            : `Gestiona cada uno de tus visitantes o personas autorizadas.`
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <Card className="mb-3">
        <FalconCardHeader
          title={params.type === 1 ? "Visitantes" : "Autorizados"}
        >
          <Row className="align-items-center justify-content-between">
            <Col>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button
                    onClick={() => {
                      setParams((prev) => ({ ...prev, type: 1 }));
                    }}
                    disabled={!!params.type}
                    color={params.type ? "primary" : "falcon-default"}
                  >
                    Visitantes
                  </Button>
                </InputGroupAddon>
                <InputGroupAddon addonType="append">
                  <Button
                    onClick={() => {
                      setParams((prev) => ({ ...prev, type: 0 }));
                    }}
                    disabled={!!!params.type}
                    color={!params.type ? "primary" : "falcon-default"}
                  >
                    Autorizados
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </Col>
            <Or cond={role}>
              <Col
                value={"property"}
                xs={12}
                md={"auto"}
                className="mt-3 mt-md-0 text-center text-md-right"
              >
                <ButtonIcon
                  icon={faPlus}
                  color="falcon-default"
                  onClick={() => history.push("/dashboard/visitors/create")}
                >
                  Añadir {params.type === 1 ? "visitante" : "autorizado"}
                </ButtonIcon>
              </Col>
              <Col
                value={"safety"}
                xs={12}
                md={"auto"}
                className="mt-3 mt-md-0 text-center text-md-right"
              >
                <ButtonIcon
                  icon={faHistory}
                  color="falcon-default"
                  onClick={() => history.push("/dashboard/visitors/history")}
                >
                  Historial de entradas
                </ButtonIcon>
              </Col>
            </Or>
          </Row>
          <Row className="mt-3">
            <Col className="d-flex">
              <Input
                type="text"
                value={textSearch}
                onKeyPress={(event) => {
                  if (event.key === "Enter") applyVisitorSearch(event.target.value);
                }}
                onChange={(event) => {
                  const value = event.target.value;
                  setTextSearch(value);
                  if (!value.trim()) {
                    setParams((prev) => ({ ...prev, search: null }));
                  }
                }}
                placeholder="Buscar por nombre, cédula, teléfono, correo, placa o inmueble..."
                className="search-input mr-2"
              />
              <ButtonIcon
                icon={faSearch}
                color="falcon-default"
                className="text-nowrap"
                onClick={() => applyVisitorSearch()}
              >
                Buscar
              </ButtonIcon>
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody className={isIterableArray(data) ? "p-0 fs--1" : "fs--1"}>
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Or value={true}>
              <Table striped responsive>
                <thead>
                  <tr>
                    <th className="align-middle">DNI</th>
                    <th className="align-middle">Nombre</th>
                    <th className="align-middle">Placa del vehículo</th>

                    <th className="text-center align-middle">
                      Fecha de entrada
                    </th>
                    <th className="text-center align-middle">
                      Fecha de salida
                    </th>
                    <th className="text-center align-middle">Estado</th>
                    {(role === "manager" || role === "safety") && (
                      <th className="text-center align-middle">Opciones</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {data.map(
                    (
                      {
                        id,
                        property,
                        data: {
                          address,
                          dni,
                          firstname,
                          image,
                          lastname,
                          isCompany,
                          phone,
                        },
                        start_at,
                        end_at,
                        plate_number,
                        is_used,
                      },
                      i
                    ) => (
                      <tr key={i}>
                        <td className="align-middle">
                          <b>
                            {dni?.charAt(0)}
                            <NumberFormat
                              displayType="text"
                              thousandSeparator
                              value={dni?.substring(1, 30)}
                            />
                          </b>
                        </td>
                        <td className="align-middle">
                          {firstname + " " + lastname}
                        </td>
                        <td className="align-middle">
                          {plate_number != null ? plate_number : 'No se especificó'}
                        </td>
                        <td className="text-center align-middle">
                          {moment(start_at).format("DD/MM/YYYY")}
                        </td>
                        <td className="text-center align-middle">
                          {moment(end_at).format("DD/MM/YYYY")}
                        </td>
                        <td className="text-center align-middle">
                          {is_used ? (
                            <span className="badge badge-soft-success py-1">En Sitio</span>
                          ) : moment().isAfter(moment(end_at)) ? (
                            <span className="badge badge-soft-danger py-1">Expirado</span>
                          ) : moment().isBefore(moment(start_at)) ? (
                            <span className="badge badge-soft-warning py-1">Pendiente</span>
                          ) : (
                            <span className="badge badge-soft-primary py-1">Aprobado</span>
                          )}
                        </td>
                        <If cond={["manager", "safety"]}>
                          <Or value={role}>
                            <td className="text-center align-middle">
                              <UncontrolledDropdown direction="left">
                                <DropdownToggle
                                  color="falcon-default"
                                  size="sm"
                                >
                                  <FontAwesomeIcon icon="ellipsis-h" />
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <DropdownItem
                                    onClick={() =>
                                      history.push(
                                        `/dashboard/visitors/${id}`,
                                        {
                                          visitor: {
                                            property,
                                            id,
                                            data: {
                                              address,
                                              dni,
                                              firstname,
                                              id,
                                              image,
                                              lastname,
                                              isCompany,
                                              phone,
                                            },
                                            start_at,
                                            end_at,
                                          },
                                        }
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      className="mr-2"
                                      icon={faInfoCircle}
                                    />
                                    Ver detalles
                                  </DropdownItem>
                                  <If cond={["safety"]}>
                                    <Or value={role}>
                                      <DropdownItem
                                        onClick={() => {
                                          setVisitorId(id);
                                          collapseOneOpen(true);
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          className="mr-2"
                                          icon={faCheck}
                                        />{" "}
                                        Marcar entrada de{" "}
                                        {params.type === 1
                                          ? "visitante"
                                          : "autorizado"}
                                      </DropdownItem>
                                    </Or>
                                  </If>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </Or>
                        </If>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </Or>
            <Or value={false} cond={!!error}>
              <Message
                className="p-3"
                color={"info"}
                icon={faInfoCircle}
                value={false}
              >
                <>
                  No hay {params.type === 1 ? "visitantes" : "autorizados"}{" "}
                  registrados.
                </>
              </Message>
              <Message
                className="p-3"
                color={"danger"}
                icon={faInfoCircle}
                value={true}
              >
                <>
                  Esta página no está disponible
                  <Button
                    data-testid="Button"
                    color="link"
                    size="sm"
                    className="ml-1 pl-0"
                    onClick={() => history.goBack()}
                  >
                    Volver
                  </Button>
                </>
              </Message>
            </Or>
          </PreloadState>
        </CardBody>
        {isIterableArray(data) && (
          <CardFooter>
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={params.type === 1 ? "visitantes" : "autorizados"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
      {handleModalConfirm()}
    </>
  );
};

export default Visitors;
